<template>
   
    <!-- /.modal -->
    <!-- FOOTER   -->
    <footer class="footer b-t b-grey">
        <div class="copyright">2016 &copy; Cash Depot - Todos los derechos reservados.</div>
    </footer>
    <div>
        <!-- OLD DIV VERSION    <div class="col-md-10 col-sm-9 col-md-offset-2 col-sm-offset-3 content container-fluid">-->
        <div class="col-xs-12 content container-fluid">
            <div class="wrapper">
                <div class="container-wrapper">
                    <div id="alerts-container">
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-xs-12">
                    <a
                        :disabled="loadingTable"
                        class="btn btn-default pull-right"
                        href="/#!/administrator/promotion/create">
                        <span
                            class="glyphicon glyphicon-plus">
                        </span> Crear Promocion
                    </a>
                </div>
            </div>
            <div id="app" class="ui vertical stripe segment">
                <div class="row">
                    <div class="col-xs-12 m-t-20">
                        <div class="table-responsive">
                            <div id="content" class="ui basic segment">
                                <table
                                    id="table-with-sorting"
                                    class="table data-table with-sorting table-striped tablesorter payment-batch-table
                                           sortable">
                                    <thead>
                                        <tr>
                                            <th>id</th>
                                            <th>Title</th>
                                            <th>Menu</th>
                                        </tr>
                                    </thead>
                                    <tbody v-if="!loadingTable">
                                        <tr v-for="promotion in promotions">
                                           <td>{{promotion.id}}</td>
                                           <td>{{promotion.title}}</td>
                                           <td>
                                               <a href="/#!/administrator/promotion/{{promotion.id}}">Editar</a> |
                                               <a @click="deletePromotion(promotion.id);">eliminar</a>
                                            </td>
                                        </tr>
                                    </tbody>
                                    <tfoot v-show="!loadingTable">
                                        <tr>
                                            <th colspan="12">
                                                <div class="row">
                                                    <div class="col-xs-12">
                                                        <pagination
                                                            :total="total"
                                                            :page-size="pageSize"
                                                            :callback="pageChanged"
                                                            :options="paginationOptions"
                                                            nav-class="padding-10"
                                                            ul-class="bg-color-red"
                                                            li-class="txt-color-blue">
                                                        </pagination>
                                                    </div>
                                                </div>
                                            </th>
                                        </tr>
                                    </tfoot>
                                </table>
                                <template v-if="loadingTable">
                                    <div style="text-align:center">
                                        <span class="fa fa-spin fa-spinner"></span>
                                    </div>
                                </template>
                            </div>
                        </div>
                        <!--</div>-->
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- CREATE OFFERS -->
    <create-edit-offers :operation="modalOperation" :offer="selectedOffer"></create-edit-offers>
    <!-- Modal -->
    <div class="modal fade" id="eraseArchiveModal" role="dialog">
        <div class="modal-dialog">
            <!-- Modal content-->
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                    <h4 class="modal-title">Confirmación</h4>
                </div>
                <div class="modal-body">
                    <p>Â¿Borrar esta oferta?</p>
                </div>
                <div class="modal-footer">
                    <button
                        type="button"
                        class="btn btn-default"
                        data-dismiss="modal"
                        @click="deleteOffer()">
                        Borrar
                    </button>
                    <button
                        type="button"
                        class="btn btn-default"
                        data-dismiss="modal">
                        Cerrar
                    </button>
                </div>
            </div>
        </div>
    </div>
    <!-- Modal -->
    <div class="modal fade" id="UnarchiveModal" role="dialog">
        <div class="modal-dialog">
            <!-- Modal content-->
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                    <h4 class="modal-title">Confirmación</h4>
                </div>
                <div class="modal-body">
                    <p>¿Desarchivar esta oferta?</p>
                </div>
                <div class="modal-footer">
                    <button
                        type="button"
                        class="btn btn-default"
                        data-dismiss="modal"
                        @click="unarchiveOffer()">
                        Desarchivar
                    </button>
                    <button
                        type="button"
                        class="btn btn-default"
                        data-dismiss="modal">
                        Cerrar
                    </button>
                </div>
            </div>
        </div>
    </div>
    <!-- Modal -->
    <div class="modal fade" id="archiveModal" role="dialog">
        <div class="modal-dialog">
            <!-- Modal content-->
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                    <h4 class="modal-title">Confirmación</h4>
                </div>
                <div class="modal-body">
                    <p>¿Archivar esta oferta?</p>
                </div>
                <div class="modal-footer">
                    <button
                        type="button"
                        class="btn btn-default"
                        data-dismiss="modal"
                        @click="archiveOffer()">
                        Archivar
                    </button>
                    <button
                        type="button"
                        class="btn btn-default"
                        data-dismiss="modal">
                        Cerrar
                    </button>
                </div>
            </div>
        </div>
    </div>
    </div>
</template>

<script>
import Pagination from "../utilities/pagination.vue";
export default {
  data() {
    return {
      currentPage: 1,
      modalOperation: "create",
      loadingTable: true,
      total: 1000,
      pageSize: 50,
      paginationOptions: {
        // Not required to pass this configurations
        offset: 1,
        previousText: "Anterior",
        nextText: "Siguiente",
        alwaysShowPrevNext: true,
      },
      selectedProvider: "",
      sortBy: "id",
      sortOrder: "DESC",
      promotions: [],
      moreParams: ["q=(is_deleted:0)"],
    };
  },
  components: {
    Pagination,
  },
  created() {
    this.user_id = this.$route.query.id;

    if (!this.user_id) {
      this.user_id = window.localStorage.getItem("user_id");
    } else {
      window.localStorage.setItem("user_id", this.user_id);
    }
    this.getPromotions();
  },
  methods: {
    sort(selectedColumn, isString) {
      if (this.sortBy == selectedColumn && !isString) {
        if (this.sortOrder == "ASC") {
          this.sortOrder = "DESC";
        } else {
          this.sortOrder = "ASC";
        }
      } else if (this.sortBy == selectedColumn && isString) {
        if (this.sortOrder == "DESC") {
          this.sortOrder = "ASC";
        } else {
          this.sortOrder = "DESC";
        }
      } else if (this.sortBy !== selectedColumn && !isString) {
        this.sortOrder = "DESC";
      } else if (this.sortBy !== selectedColumn && isString) {
        this.sortOrder = "ASC";
      }

      this.sortBy = selectedColumn;
      this.getPromotions();
    },
    pageChanged(page) {
      this.getPromotions(page);
      this.currentPage = page;
      // Exec your response to server passing 'page' params as clicked button paging
    },
    getPromotions: function (page = 1) {
      let params = "";
      this.loadingTable = true;
      this.$http
        .get(
          apiUrl +
            `/promotions?format=true&page=${page}&sort=${this.sortBy}|${this.sortOrder}`
        )
        .then((response) => {
          this.promotions = response.body.data;
          this.total = response.body.total_pages * 50;
          this.loadingTable = false;
        });
    },

    deletePromotion(id) {
      if (confirm("Quieres eliminar esta promocion?")) {
        this.$http
          .delete(apiUrl + "/promotions/" + id)
          .then(function (response) {
            location.reload();
          })
          .catch(function (error) {
            location.reload();
          });
      }
    },
  },

  events: {
    "reload-table"() {
      this.getPromotions(this.currentPage);
    },
    "updated-offer"() {
      this.getPromotions(this.currentPage);
    },
  },
};
</script>

<style scoped>
.txt-blue {
  color: #0000ee;
}
</style>



// WEBPACK FOOTER //
// index.vue?e28c1e60